import { useGetConsumerLoyaltyStatus } from '../../state/loyalty/loyalty.hooks'
import { useSetupApplePay } from '../../state/applepay/hooks'

export const useAuthenticatedGlobalFetch = (): void => {
  useSetupApplePay()
  // TODO: Remove, 👋 pulse
  useGetConsumerLoyaltyStatus()
}
